import {BrowserRouter as Router, Routes, Route} from 'react-router-dom'
import Home from './screens/Home';
import Policy from './screens/Policy';
import TermsAndCondition from './screens/TermsAndCondition';

function App() {
  return (
    <Router>
      <Routes>
        <Route element={<Home />} path='/' />
        <Route element={<Home />} path='*' />
        <Route element={<Policy />} path='/policy' />
        <Route element={<TermsAndCondition />} path='/terms&condition' />
      </Routes>
    </Router>
  );
}

export default App;
